import React from 'react';
import { Images } from '../../Tenants';
import './Logo.scss';

const Logo = () => {
  return (
  <div className="logo">
    <div style={{paddingTop: Images.paddingTop}} />
    <img
      // alt="alabastar"
      className={Images.logoStyles}
      src={Images.loginLogo}
    />
  </div>
  )};

export default Logo;
